import React from 'react'
import './trip-line.style.scss'

const TripLineSector = () => {
	return (
		<React.Fragment>
			<div className="circle" />
			<div className="line" />
		</React.Fragment>
	)
}

const TripLine = React.memo((props) => {
	const { qttTrips } = props

	return (
		<div className="line-wrapper">
			<div className="circle" />
			<div className="line" />
			{Array.from({ length: qttTrips }).map((_, index) => (
				<TripLineSector key={index} />
			))}
			<div className="circle"></div>
		</div>
	)
})

export default TripLine
